// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"558":"fae39dc6","691":"cbf07116"}[chunkId] + ".chunk.css";
};